export const CampaignTypes = {
    'updateCampaign': 'Manager_campaign_updateCampaign',
    'setField'      : 'Manager_campaign_setField',
    'update'        : 'Manager_campaign_update',
    'updateTeams'   : 'Manager_campaign_updateTeams',
    'deleteTeam'    : 'Manager_campaign_deleteTeam',
}
